var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "person" }, [
    _c(
      "div",
      { staticClass: "person__section" },
      [
        _c(
          "div",
          { staticClass: "custom-switcher" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.personMode,
                  expression: "personMode",
                },
              ],
              attrs: {
                type: "radio",
                name: "person-mode",
                id: "pm-new",
                value: "new",
              },
              domProps: { checked: _vm._q(_setup.personMode, "new") },
              on: {
                change: function ($event) {
                  _setup.personMode = "new"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "pm-new" } }, [_vm._v("Новый турист")]),
            _vm._v(" "),
            _setup.props.copy_person_list.length
              ? [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _setup.personMode,
                        expression: "personMode",
                      },
                    ],
                    attrs: {
                      type: "radio",
                      name: "person-mode",
                      id: "pm-current",
                      value: "current",
                    },
                    domProps: { checked: _vm._q(_setup.personMode, "current") },
                    on: {
                      change: function ($event) {
                        _setup.personMode = "current"
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "pm-current" } }, [
                    _vm._v("Турист текущей заявки"),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _setup.personMode,
                  expression: "personMode",
                },
              ],
              attrs: {
                type: "radio",
                name: "person-mode",
                id: "pm-other",
                value: "other",
              },
              domProps: { checked: _vm._q(_setup.personMode, "other") },
              on: {
                change: function ($event) {
                  _setup.personMode = "other"
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "pm-other" } }, [
              _vm._v("Из других заявок"),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _setup.personMode === "current" && _setup.props.copy_person_list.length
          ? _c(
              "div",
              { staticClass: "person__line" },
              [
                _c(_setup.MySelect, {
                  staticClass: "custom-field__field",
                  attrs: {
                    label: _setup.props.copy_person_title,
                    list: _setup.props.copy_person_list,
                    choosed: _setup.copy_person_val,
                    onlyone: true,
                  },
                  on: {
                    input: function ($event) {
                      return _setup.copy_person_set($event)
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "custom-field" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn--blue custom-field__but",
                      attrs: { disabled: !_setup.copy_person_val },
                      on: { click: _setup.copy_person_do },
                    },
                    [_vm._v(_vm._s(_setup.props.copy_person_button))]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("Все ранее введенные поля очистятся\n            "),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _setup.personMode === "other"
          ? _c(_setup.PersonImport, {
              staticClass: "person__line",
              attrs: { target: _setup.props.sid },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "person__section" }, [
      _c(
        "div",
        { staticClass: "person__line" },
        [
          _c(_setup.FieldInputNew, {
            staticClass: "custom-field__field",
            attrs: {
              vest: _setup.person.vest,
              field: _setup.person.doc_gra,
              title: "Гражданство",
              touched: _setup.touched,
            },
            on: { input: _setup.set_document_on_gra },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "person__section" }, [
      _setup.is_ru()
        ? _c(
            "div",
            { staticClass: "person__line" },
            [
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.fname,
                  touched: _setup.touched,
                  title: "Фамилия",
                },
              }),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.iname,
                  touched: _setup.touched,
                  title: "Имя",
                },
              }),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.oname,
                  touched: _setup.touched,
                  title: "Отчество",
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "person__line" },
            [
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.flname,
                  touched: _setup.touched,
                  title: "Фамилия латиница",
                },
              }),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.ilname,
                  touched: _setup.touched,
                  title: "Имя латиница",
                },
              }),
            ],
            1
          ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "person__section" }, [
      _c(
        "div",
        { staticClass: "person__line" },
        [
          _c(_setup.FieldInputNew, {
            staticClass: "custom-field__field",
            attrs: {
              vest: _setup.person.vest,
              field: _setup.person.male,
              touched: _setup.touched,
              title: "Пол",
            },
          }),
          _vm._v(" "),
          _c(_setup.FieldInputNew, {
            staticClass: "custom-field__field",
            attrs: {
              vest: _setup.person.vest,
              field: _setup.person.born,
              touched: _setup.touched,
              title: "Дата рождения",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "person__section" }, [
      _c(
        "div",
        { staticClass: "person__line" },
        [
          _c(_setup.FieldInputNew, {
            staticClass: "custom-field__field",
            attrs: {
              vest: _setup.person.vest,
              field: _setup.person.doc_type,
              touched: _setup.touched,
              title: "Документ",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "person__section" }, [
      _c(
        "div",
        { staticClass: "person__line" },
        [
          _c(_setup.FieldInputNew, {
            staticClass: "custom-field__field",
            attrs: {
              vest: _setup.person.vest,
              field: _setup.person.doc_serie,
              touched: _setup.touched,
              title: "Серия",
            },
          }),
          _vm._v(" "),
          _c(_setup.FieldInputNew, {
            staticClass: "custom-field__field",
            attrs: {
              vest: _setup.person.vest,
              field: _setup.person.doc_number,
              touched: _setup.touched,
              title: "Номер",
            },
          }),
          _vm._v(" "),
          _c(_setup.FieldInputNew, {
            staticClass: "custom-field__field",
            attrs: {
              vest: _setup.person.vest,
              field: _setup.person.doc_issue,
              touched: _setup.touched,
              title: "Дата выдачи",
            },
          }),
          _vm._v(" "),
          _setup.hasValid()
            ? _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.doc_valid,
                  touched: _setup.touched,
                  title: "Действителен до",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _setup.is_ru() && _setup.isZps()
        ? _c(
            "div",
            { staticClass: "person__line" },
            [
              _c("div", { staticClass: "custom-field ruen" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--blue custom-field__but",
                    on: {
                      click: function ($event) {
                        return _setup.translit_fio(_setup.person)
                      },
                    },
                  },
                  [_vm._v("RU->EN")]
                ),
              ]),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.flname,
                  touched: _setup.touched,
                  title: "Фамилия латиница",
                },
              }),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.ilname,
                  touched: _setup.touched,
                  title: "Имя латиница",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.is_cust && _setup.isPs()
        ? _c(
            "div",
            { staticClass: "person__line" },
            [
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.doc_unitcode,
                  touched: _setup.touched,
                  title: "Подразделение",
                },
              }),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.doc_authority,
                  touched: _setup.touched,
                  title: "Кем выдан",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.is_cust
        ? _c(
            "div",
            { staticClass: "person__line" },
            [
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.doc_address,
                  touched: _setup.touched,
                  title: "Адрес регистрации",
                },
              }),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.doc_zip,
                  touched: _setup.touched,
                  title: "Почтовый индекс",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _setup.is_cust
      ? _c("div", { staticClass: "person__section" }, [
          _c("div", { staticClass: "person__section-title" }, [
            _vm._v("Контактная информация"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "person__line" },
            [
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.phone,
                  touched: _setup.touched,
                  title: "Номер телефона",
                },
              }),
              _vm._v(" "),
              _c(_setup.FieldInputNew, {
                staticClass: "custom-field__field",
                attrs: {
                  vest: _setup.person.vest,
                  field: _setup.person.email,
                  touched: _setup.touched,
                  title: "Электронная почта",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }